<template>
    <div class="box">
        <div class="container">
            <headerWX class="headerWX"></headerWX>
            <img class="bg" src="@/assets/imgs/MyRule/bg.png" alt="">
            <div class="container_body">
                <div class="task">
                    <!-- 每日任务 -->
                    <!-- <div class="dailyMission taskList_item">
                            <img src="@/assets/imgs/DoubleEleven/dailyMission.png" alt="">
                            <div class="dailyMission_item">
                                <div class="taskList_list" v-for="value in ActivityInfo.dailyTasks" :key="value.taskId">
                                    <div class="text">{{ value.taskDesc }}</div>
                                    <div class="award">
                                        <div class="award_item">
                                            {{ value.rewardItemName }}X{{ value.rewardNum }}
                                        </div>
                                        <div class="btn">
                                            <img v-if="value.taskUrl && value.isCompleted == false"
                                                src="@/assets/imgs/DoubleEleven/goToAccomplish.png" @click="go(value)">
                                            <img v-else-if="value.isCompleted == true && value.isClaimed == false"
                                                src="@/assets/imgs/DoubleEleven/get_btn.png" @click="receive(value)"
                                                alt="">
                                            <img v-else-if="value.isClaimed == true"
                                                src="@/assets/imgs/DoubleEleven/OverGet_btn.png" alt="">
                                            <img v-else style="filter: grayscale(100%);"
                                                src="@/assets/imgs/DoubleEleven/get_btn.png">
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div> -->
                    <!-- VIP福利 -->
                    <div class="VIPBenefits taskList_item">
                        <img src="@/assets/imgs/MyRule/VIPBenefits.png" alt="" style="width: 100%;">
                        <div class="VIPBenefits_item">
                            <div class="VIPBenefits_list">
                                <div class="text">{{
                                    ActivityInfo.dailyTasks[0]?.taskName
                                }}</div>
                                <div class="award">
                                    <div class="award_item">
                                        <img src="@/assets/imgs/MyRule/icon.png" alt="">
                                        回溯券X{{ ActivityInfo.dailyTasks[0]?.rewardNum }}
                                    </div>
                                    <div class="btn">
                                        <img v-if="ActivityInfo.dailyTasks[0]?.currentProgress == 0"
                                            @click="go(ActivityInfo.dailyTasks[0])"
                                            src="@/assets/imgs/MyRule/go_complete.png" alt="">
                                        <img v-else-if="ActivityInfo.dailyTasks[0]?.isClaimed == false"
                                            src="@/assets/imgs/MyRule/get_btn.png" @click="getVip1()">
                                        <img v-else-if="ActivityInfo.dailyTasks[0]?.isCompleted == true"
                                            src="@/assets/imgs/MyRule/OverGet_btn.png">
                                    </div>
                                </div>
                            </div>
                            <div class="VIPBenefits_list">
                                <div class="text">VIP等级达到LV5及以上</div>
                                <div class="award">
                                    <div class="award_item">
                                        <img src="@/assets/imgs/MyRule/icon.png" alt=""></img>
                                        回溯券X10
                                    </div>
                                    <div class="btn">
                                        <img v-if="ActivityInfo.vipBonusStatus == 0" style="filter: grayscale(100%);"
                                            src="@/assets/imgs/MyRule/get_btn.png" alt="">
                                        <img v-else-if="ActivityInfo.vipBonusStatus == 1"
                                            src="@/assets/imgs/MyRule/get_btn.png" @click="getVip2()">
                                        <img v-else-if="ActivityInfo.vipBonusStatus == 2"
                                            src="@/assets/imgs/MyRule/OverGet_btn.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 助力券 -->
                    <div class="ticket taskList_item">
                        <img src="@/assets/imgs/MyRule/ticket.png" style="width: 100%;" alt="">
                        <div class="ticket_item">
                            <div class="ticket_num">{{ ActivityInfo.supportTickets }}</div>
                            <div class="ticket_num">{{ ActivityInfo.supportTicketsTotalUsed }}</div>
                            <div class="ticket_num">{{ ActivityInfo.supportTicketsTotalEarned }}</div>
                        </div>
                    </div>
                    <!-- 宠物投票 -->
                    <div class="laborUnion">
                        <div class="laborUnion_item" v-for="value in ActivityInfo.guildList" :key="value.guildId">
                            <img src="@/assets/imgs/MyRule/laborUnion.png" alt=""></img>
                            <div class="laborUnion_list">
                                <p class="name">{{ value.serverName }}</p>
                                <div class="headPortrait_img">
                                    <img :src="value.guildIcon" alt="">
                                </div>
                                <!-- <p class="area">{{ value.guildName }}</p> -->
                                <p class="area"></p>
                                <div class="btn">
                                    <img @click="Help(value, 1)" src="@/assets/imgs/MyRule/help_noeBtn.png" alt="">
                                    <img @click="Help(value, 10)" src="@/assets/imgs/MyRule/help_tenBtn.png" alt="">
                                </div>
                            </div>
                            <!-- 得票数 -->
                            <el-tooltip class="item" effect="dark" :content="value.voteCount" placement="top">
                                <div class="vote_num">
                                    <img src="@/assets/imgs/MyRule/vote_num.png" alt="">
                                    <div class="text">
                                        {{ value.voteCount }}
                                    </div>
                                </div>
                            </el-tooltip>

                        </div>
                    </div>
                    <!-- 累计票数 -->
                    <div class="Cumulative_vote">
                        <div class="text">
                            <img src="@/assets/imgs/MyRule/Cumulative_vote/text.png" alt="">
                        </div>
                        <!-- 进度 -->
                        <div class="progress">
                            <img src="@/assets/imgs/MyRule/Cumulative_vote/Progress_bg.png" alt="">
                            <div class="progress_bar" :style="{ width: (ActivityInfo.userVoteCount * 5) + '%' }">
                                <img src="@/assets/imgs/MyRule/Cumulative_vote/Progress.png" alt="">
                            </div>
                        </div>
                        <!-- num -->
                        <div class="num">
                            <img src="@/assets/imgs/MyRule/Cumulative_vote/num.png" alt=""></img>
                        </div>
                        <!-- 奖励 -->
                        <div class="award">
                            <el-tooltip class="item" effect="dark" :content="ActivityInfo.userVoteBonus.bonusName"
                                placement="top">
                                <img :src="ActivityInfo.userVoteBonus.img" alt="" />
                            </el-tooltip>
                            <img style="cursor: pointer;" v-if="ActivityInfo.userVoteBonus.bonusStatus == 0"
                                src="@/assets/imgs/MyRule/Cumulative_vote/0.png" alt="">
                            <img style="cursor: pointer;" v-else-if="ActivityInfo.userVoteBonus.bonusStatus == 1"
                                src="@/assets/imgs/MyRule/Cumulative_vote/1.png" alt="" @click="getVoteReward()">
                            <img style="cursor: pointer;" v-else-if="ActivityInfo.userVoteBonus.bonusStatus == 2"
                                src="@/assets/imgs/MyRule/Cumulative_vote/2.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="explain">
                    <img src="@/assets/imgs/MyRule/explain.png" alt="">

                    <div class="explain_body">
                        <div class="tit">
                            <img src="@/assets/imgs/MyRule/explain_Tit.png" alt="">
                        </div>
                        <div class="coenter">
                            <p style="text-align: center;color: red;">活动时间：2026年1月29日—2026年2月8日24点</p>
                            <p>1.您每次助力将消耗一张回溯券。</p>
                            <p>2.活动期间累计回溯20次后可在页面中领取活动限定称号-宠盟返场先锋。</p>
                            <p>3.活动期间内得票数超过100票的宠物将在新春活动中进行返场。</p>
                            <p>4.活动奖励为拾取绑定。</p>
                            <p>5.回溯券为活动专属货币，请在活动结束前使用，逾期作废。</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- 蒙版 -->
        <div class="masking" v-if="dialog">
            <div class="maskContent">
                <img class="mask_bg" src="@/assets/imgs/MyRule/masking_bg.png" alt="">
                <div class="close_brn" @click="dialog = false"></div>
                <div class="body">
                    <div class="help" v-if="dialog_type == 'help'">
                        <div class="tit">温馨提示</div>
                        <div class="help_tit">投票成功将消耗 <span>{{ dialog_item.Times }}张</span> 回溯券</div>
                        <div class="possess_tit">您当前拥有<span>{{ ActivityInfo.supportTickets }}</span>张回溯券</div>
                        <div class="possess_tit">当前投票的宠物是<span>{{ dialog_item.serverName }}</span></div>
                        <div class="btn">
                            <img @click="goHele" src="@/assets/imgs/MyRule/confirm_btn.png" alt="">
                            <img @click="dialog = false" src="@/assets/imgs/MyRule/cancel_btn.png" alt="">
                        </div>
                    </div>
                    <div class="shop" v-if="dialog_type == 'shop'">
                        <div class="type_img">
                            <img :src="dialog_item.itemImg" alt="">
                        </div>
                        <div class="shop_tit">您确认要兑换"<span>{{ dialog_item.itemName }}</span> "吗</div>
                        <div class="tit">本次兑换操作不可逆</div>
                        <div class="btn">
                            <img @click="goShop" src="@/assets/imgs/MyRule/confirm_btn.png" alt="">
                            <img @click="dialog = false" src="@/assets/imgs/MyRule/cancel_btn.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headerWX from "@/components/Header";
import Cookies from 'js-cookie'

import {
    claimVipBonusApi, // 领取VIP福利
    getActivityInfoApi, // 获取宠物投票活动信息
    getPersonalContributionRankApi,// 获取个人贡献榜
    getRankListApi,// 获取宠物排行榜
    voteApi,// 宠物投票
    claimDailyTaskRewardApi,// 领取每日任务奖励
    claimUserVoteBonusApi,// 领取投票奖励
} from '@/api/PetVoting'
export default {
    components: {
        headerWX,
    },
    data() {
        return {
            dialog: false,
            dialog_type: '', //弹窗类型
            dialog_item: {}, // 弹窗数据

            ActivityInfo: [], // 活动数据
            PersonalContributionRank: [],  //个人工会排行
        }
    },
    created() {
        // this.openPageScroll()
        // 下一帧（DOM 更新完后）再滚动
        this.$nextTick(() => {
            this.scrollToTop()
        })
    },
    mounted() {
        this.init()
    },
    methods: {



        //打开购买商品弹窗
        go_shop(item) {
            this.dialog_item = item
            this.dialog_type = 'shop'
            this.dialog = true

        },
        //购买商品
        async goShop() {
            this.$message.info('错误，请刷新页面')
        },
        // 打开工会助力弹窗
        Help(item, Times) {
            item.Times = Times

            this.dialog_item = item
            this.dialog_type = 'help'
            this.dialog = true
            // console.log(item);

        },
        //工会助力
        async goHele() {
            if (this.ActivityInfo.supportTickets <= 0 || this.ActivityInfo.supportTickets < this.dialog_item.Times) {
                this.$message.info('回溯券不足,请先去获取回溯券吧!')
            } else {
                await voteApi({
                    activityName: '2026_animal_vote_activity',
                    userId: Cookies.get('cwsl_userId'),
                    guildId: this.dialog_item.guildId,
                    voteNum: this.dialog_item.Times
                }).then(({ data }) => {
                    if (data.state == 200) {
                        this.$message.success(data.data.message)
                        this.dialog_item = {}
                        this.dialog_type = ''
                        this.dialog = false
                        this.init()
                    } else {
                        this.$message.error(data.data.message)
                    }
                })
            }
        },

        // 去完成
        go(item) {
            if (item.taskUrl.indexOf("http") != -1) {
                window.open(item.taskUrl, "_blank");
            } else {
                this.$router.push({
                    path: item.taskUrl,
                });
            }
        },

        //每日任务
        async getVip1() {
            await claimDailyTaskRewardApi({
                activityName: '2025_animal_vote_activity',
                userId: Cookies.get('cwsl_userId'),
                taskId: 1
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.$message.success(data.data.message)
                    this.init()
                } else {
                    this.$message.error(data.message)
                }
            })
        },
        // Vip领取
        async getVip2() {
            await claimVipBonusApi({
                activityName: '2025_animal_vote_activity',
                userId: Cookies.get('cwsl_userId'),
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.$message.success(data.data.message)
                    this.init()
                } else {
                    this.$message.error(data.message)
                }
            })
        },

        //领取投票奖励
        async getVoteReward() {
            await claimUserVoteBonusApi({
                activityName: '2026_animal_vote_activity',
                userId: Cookies.get('cwsl_userId'),
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.$message.success(data.data.message)
                    this.init()
                } else {
                    this.$message.error(data.message)
                }
            })
        },

        //初始化
        async init() {
            //个人工会排行
            await getPersonalContributionRankApi({
                activityName: '2025_animal_vote_activity',
                userId: Cookies.get('cwsl_userId'),
            })
                .then(({ data }) => {
                    if (data.state == 200) {
                        this.PersonalContributionRank = data.data.rankList
                    }
                })

            // 活动数据
            await getActivityInfoApi({
                activityName: '2026_animal_vote_activity',
                userId: Cookies.get('cwsl_userId'),
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.ActivityInfo = data.data
                }
            })
        },

        scrollToTop() {
            // 确保容器存在
            if (this.$refs.scrollContainer) {
                this.$refs.scrollContainer.scrollTop = 0;
            }
            // 同时让整个页面也滚动到顶部（防止有 window 滚动）
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        },
    }
}


</script>
<style lang="less">
#app {
    background: linear-gradient(to bottom, #1b4a5f, #1c4c47, #0a2720);
}
</style>
<style lang="less" scoped>
.container {
    background-image: url(../../assets/imgs/MyRule/bg.png);

    // background: linear-gradient(to right, rgb(237, 33, 58), rgb(147, 41, 30));
    min-width: 1200px;
    max-width: 2000px;
    margin: auto;
    position: relative;
    // padding-bottom: 300px;
    overflow: hidden;

    .headerWX {
        position: absolute;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
    }

    .bg {
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .container_body {
        position: relative;
        // top: 180px;
        width: 70%;
        left: 50%;
        transform: translateX(-50%);

        // 每日任务 排行榜
        .task {

            // 公用
            .taskList_item {
                text-align: center;
                position: relative;

                img {
                    max-width: 100%;
                }
            }

            // vip福利
            .VIPBenefits {
                .VIPBenefits_item {
                    position: absolute;
                    top: 32%;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 88%;
                    min-width: 500px;
                    height: 54%;
                    // background: rgba(49, 175, 114, 0.644);
                    display: flex;
                    flex-direction: column;

                    .VIPBenefits_list {
                        flex: 1;
                        display: flex;

                        .text {
                            width: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #465FFF;
                            font-size: 20px;
                            font-weight: 600;
                        }

                        .award {
                            width: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;

                            .award_item {
                                color: #465FFF;
                                font-size: 20px;
                                font-weight: 600;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                flex: 1;

                                >img {
                                    width: 20%;
                                    margin-right: 5px;
                                }
                            }

                            .btn {
                                width: 30%;

                                img {
                                    width: 70%;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }

            //助力券
            .ticket {
                .ticket_item {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 92%;
                    min-width: 500px;
                    // max-width: 760px;
                    height: 34%;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;

                    .ticket_num {
                        font-weight: 600;
                        font-size: 20px;
                        color: #465FFF;
                    }
                }
            }

            // 工会投票
            .laborUnion {
                width: 100%;
                display: flex;
                justify-content: space-evenly;

                >div {
                    flex: 1;
                    text-align: center;
                    position: relative;

                    >img {
                        width: 100%;
                    }
                }

                .laborUnion_list {
                    position: absolute;
                    top: 10%;
                    height: 78%;
                    width: 80%;
                    left: 50%;
                    transform: translateX(-50%);

                    .name {
                        font-weight: 600;
                        font-size: 20px;
                        color: #465FFF;
                        padding: 8% 0;
                        text-align: center;
                    }

                    .headPortrait_img {
                        width: 100%;
                        overflow: hidden;

                        >img {
                            border-radius: 50%;
                            width: 50%;
                            aspect-ratio: 1/1;

                        }
                    }

                    .area {
                        font-weight: 600;
                        font-size: 20px;
                        color: #465FFF;
                        padding: 8% 0;
                        text-align: center;
                    }

                    .btn {
                        width: 100%;
                        display: flex;
                        width: 100%;
                        justify-content: space-around;
                        align-items: center;

                        >img {
                            // max-width: 80%;
                            width: 40%;
                            cursor: pointer;
                        }
                    }
                }

                // 得票数
                .vote_num {
                    position: absolute;
                    top: 0%;
                    right: -5px;
                    width: 25%;
                    max-width: 100px;
                    min-width: 60px;
                    text-align: center;
                    font-weight: 600;
                    font-size: 18px;
                    display: inline-block;
                    user-select:none;
                    >img {
                        width: 100%;
                    }

                    .text {
                        position: absolute;
                        top: 30%;
                        left: 40%;
                        transform: translateX(-50%);
                        font-size: 20px;
                        color: #fff;
                        text-wrap: nowrap;
                        width: 65%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            // 累计票数
            .Cumulative_vote {
                width: 100%;
                display: flex;
                align-items: center;

                .text {
                    width: 14%;

                    >img {
                        width: 98%;
                    }
                }

                .progress {
                    position: relative;
                    width: 66%;

                    >img {
                        width: 100%;
                    }

                    .progress_bar {
                        position: absolute;
                        top: 47%;
                        left: 12px;
                        transform: translateY(-50%);
                        height: 69%;
                        max-width: 97% !important;
                        z-index: 10;
                        background-color: rgba(64, 224, 208, 0.61);
                        border-radius: 30px;
                        overflow: hidden;

                        >img {
                            position: absolute;
                            right: 0;
                            top: 0;
                            height: 100%;
                        }
                    }
                }

                .num {
                    width: 10%;

                    >img {
                        width: 100%;
                    }
                }

                .award {
                    width: 10%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 10px 0;
                }
            }

        }

        .explain {
            width: 100%;
            position: relative;

            >img {
                width: 100%;
            }

            .explain_body {
                position: absolute;
                top: 12%;
                left: 50%;
                transform: translateX(-50%);
                width: 90%;
                height: 77%;
                display: flex;
                flex-direction: column;

                .tit {
                    width: 100%;
                    text-align: center;
                }

                .coenter {
                    width: 100%;
                    flex: 1;
                    overflow: auto;
                    padding-top: 20px;

                    >p {
                        font-size: 1.5rem;
                        line-height: 2.5rem;
                        color: #465FFF;
                        font-weight: 600;
                    }
                }
            }
        }
    }

    .container_body::before {
        height: 180px;
        width: 1px;
        content: "";
        /* 伪元素必须有 content */
        display: block;
        /* 作为块级元素撑开高度 */
    }



}

.masking {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: rgba(0, 0, 0, 0.575);
    z-index: 1000;

    .maskContent {
        min-width: 600px;
        max-width: 1200px;
        width: 70vw;
        margin: auto;
        position: relative;
        top: 15%;
        overflow: hidden;
        // background-color: #CA4B2B;
        text-align: center;

        .mask_bg {
            max-width: 80%;
        }

        .close_brn {
            position: absolute;
            top: 6%;
            right: 17%;
            width: 4%;
            height: 9%;
            cursor: pointer;
        }

        .body {
            position: absolute;
            top: 17%;
            left: 50%;
            transform: translateX(-50%);
            width: 70%;
            height: 50%;
            // background-color: #30ca2b83;

            .help {
                width: 100%;
                height: 100%;

                .tit {
                    font-size: 20px;
                    margin: 2%;
                    font-weight: 600;
                    color: #467ADB;
                }

                .help_tit {
                    font-size: 20px;
                    margin: 2%;

                    >span {
                        color: #467ADB;
                        font-size: 25px;

                    }
                }

                .possess_tit {
                    font-size: 20px;
                    margin: 3%;

                    >span {
                        color: #467ADB;
                        font-size: 25px;

                    }
                }

                .btn {
                    width: 100%;
                    max-height: 20%;
                    position: absolute;
                    bottom: 3%;
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;

                    >img {
                        max-width: 30%;
                        cursor: pointer;
                    }
                }
            }

            .shop {
                width: 100%;
                height: 100%;

                .type_img {
                    width: 100%;
                    height: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    >img {
                        height: 100%;
                    }
                }

                .shop_tit {
                    font-size: 20px;
                    margin: 2%;

                    >span {
                        color: red;
                        font-size: 25px;

                    }
                }

                .tit {
                    font-size: 1.5rem;
                }

                .btn {
                    width: 100%;
                    max-height: 20%;
                    position: absolute;
                    bottom: 3%;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;

                    >img {
                        max-width: 30%;
                        cursor: pointer;
                    }
                }
            }
        }
    }

}
</style>